<template>
  <v-scroll-y-transition>
    <v-app-bar
      v-if="show"
      v-scroll="onScroll"
      dense
      flat
      fixed
      :color="color"
    >
      <v-flex
        shrink
        mx-auto
        class="body-2 text-center"
      >
        {{ message }}
        <router-link
          v-if="link"
          :to="link"
          class="si-announcement-link"
        >
          Read more
        </router-link>
      </v-flex>
      <v-btn
        v-if="dismissable"
        icon
        small
        @click="dismissAccounement"
      >
        <v-icon>close</v-icon>
      </v-btn>
    </v-app-bar>
  </v-scroll-y-transition>
</template>

<script>
// import { mapGetters } from 'vuex'
// import helpers from '@/mixins/helpers'

export default {
  // mixins: [ helpers ],
  props: {
    scrollThreshold: Number,
  },
  data: () => ({
    dismissed: false,
    message: "Super Info not associated with telemarketing campaign",
    link: "/announcement",
    dismissable: true,
    color: "teal accent-2",
    showRoutes: ["home"],
    scrollPos: 0,
    hide: false,
  }),
  computed: {
    show() {
      return (
        !this.hide &&
        this.message &&
        !this.dismissed &&
        this.showRoutes.includes(this.$route.name)
      );
    },
  },
  watch: {
    show(v) {
      this.$store.commit("set_announcementActive", v);
    },
    scrollPos: {
      handler(v) {
        if (this.scrollThreshold) {
          if (v > this.scrollThreshold && this.show) {
            this.hide = true;
          } else if (v < this.scrollThreshold && !this.show) {
            this.hide = false;
          }
        }
      },
      immediate: true,
    },
  },
  beforeMount() {
    if (this.message && this.show)
      this.$store.commit("set_announcementActive", true);
  },
  methods: {
    dismissAccounement() {
      this.dismissed = true;
      this.$store.commit("set_announcementActive", false);
    },
    onScroll(e) {
      this.scrollPos = e.target.scrollingElement.scrollTop;
    },
  },
};
</script>

<style lang="scss" scopped>
.si-announcement-link {
  text-decoration: none;
  color: inherit !important;
  text-transform: uppercase;
  font-weight: 500;
  margin: 0 16px;
  white-space: nowrap;
}
</style>